<template>
    <div class="list-number-container">
        <div class="list-number">
            <div class="list-number__search">
                <div class="list-number__search-input">
                    <InputSearchNumber
                        @onsearch="handleSearchNumber"
                        @input="
                            searchNumber = $event;
                            isSearchError = false;
                        "
                        :value="searchNumber"
                        :maxlength="this.getNumberLength()"
                        @enter="handleSearchNumber"
                    />
                </div>
                <button
                    class="btn list-number__search-chosen"
                    @click="handleActiveChosenNumber"
                    v-if="history !== null"
                >
                    <span
                        class="list-number__search-chosen--icon d-inline-block"
                        :class="{
                            'list-number__search-chosen--icon--active': isActiveChosenNumber,
                        }"
                    ></span>
                    <span
                        class="list-number__search-chosen--title d-inline-block"
                    >
                        Số đã cược
                    </span>
                </button>
            </div>
            <div
                class="list-number__search-error-message"
                v-show="isSearchError"
            >
                * Bạn chưa nhập số cần tìm
            </div>
            <div
                v-show="isActiveChosenNumber && history.length === 0"
                class="list-number__search-error-message"
            >
                * Bạn chưa từng cược
            </div>
            <div class="list-number__factor-container" v-if="factor > 0">
                <button
                    v-for="n in filteredFactor"
                    @click="() => setShownFactor(n.value)"
                    :key="n.value"
                    class="btn list-number__factor-container-factor"
                    :class="{
                        'list-number__factor-container-factor--active':
                            n.value === shownFactor,
                    }"
                >
                    {{ n.label }}
                </button>
            </div>
            <div class="list-number__content">
                <InputNumber
                    v-for="shownNumber in shownNumbers"
                    :numberInput="shownNumber.value"
                    :key="shownNumber.value"
                    :onChecked="() => handleCheckedNumber(shownNumber.value)"
                    :onNotChecked="
                        () => handleUnCheckedNumber(shownNumber.value)
                    "
                    :on-error-checked="onErrorChecked"
                    :should-update="countChosenNumbers < max_number"
                    :checkedMask="betData.numbers.includes(shownNumber.value)"
                    :isBet="
                        isActiveChosenNumber &&
                            history.includes(shownNumber.value)
                    "
                    ref="input"
                    :num-length="getNumberLength()"
                />
            </div>
            <div class="list-number__rule" v-html="generateRule"></div>
        </div>
    </div>
</template>

<script>
import InputSearchNumber from '@/components/common/InputSearchNumber/InputSearchNumber';
import InputNumber from '@/components/common/InputNumber/InputNumber';
import { mapGetters } from 'vuex';

export default {
    components: {
        InputSearchNumber,
        InputNumber,
    },
    data() {
        return {
            factor: 0,
            shownFactor: 0,
            shownNumbers: [],
            countChosenNumbers: 0,
            max_number: 0,
            searchNumber: '',
            isActiveChosenNumber: false,
            history: null,
            maxShowNumber: 100,
            rule: ``,
            isSearchError: false,
        };
    },
    props: {
        gameInfo: Object,
        rate: Number,
    },
    beforeMount() {
        // Check game type
        const gameType = this.gameInfo.type;
        const gameCode = this.gameInfo.code;
        if (gameType === 'dauduoi') {
            this.maxShowNumber = 10;
        }
        if (
            gameType === '3cang' ||
            gameCode === 'loto_3so' ||
            gameType === 'xiuchu'
        ) {
            this.factor = 10;
        }

        for (let i = 0; i < this.maxShowNumber; i++) {
            const numberValue = i + this.shownFactor * 100;
            this.shownNumbers.push({
                value: numberValue,
            });
        }

        this.max_number =
            this.gameInfo.max_number === 0 ? 10 : this.gameInfo.max_number;

        this.updateHistory();
        this.countChosenNumbers = this.betData.numbers.length;
    },
    watch: {
        shownFactor: function(val) {
            this.shownFactor = val;
            this.shownNumbers = [];
        },
        '$store.state.userModule.history': function() {
            this.updateHistory();
        },
        '$store.state.betModule.betData.currentGame.code': function() {
            this.isActiveChosenNumber = false;
        },
    },
    beforeUpdate() {
        this.updateNumbersWithShownFactor();
        this.countChosenNumbers = this.betData.numbers.length;
        this.history = null;
        this.updateHistory();
    },
    computed: {
        ...mapGetters({
            betData: 'betModule/betData',
            betHistory: 'userModule/history',
        }),
        filteredFactor() {
            const factorEls = [];
            for (let i = 0; i < this.factor; i++) {
                factorEls.push({
                    value: i,
                    label: `${i}00-${i}99`,
                });
            }
            return factorEls;
        },
        generateRule() {
            const generatedRule = this.gameInfo.guide.replace(
                new RegExp('{{ODDS}}', 'g'),
                () => `<span class="highlight">${this.rate}</span>`,
            );
            return `<span>${generatedRule}</span>`;
        },
    },
    methods: {
        setShownFactor: function(newShownFactor) {
            this.shownFactor = newShownFactor;
        },
        updateNumbersWithShownFactor: function() {
            this.shownNumbers = [];
            for (let i = 0; i < this.maxShowNumber; i++) {
                const numberValue = i + this.shownFactor * 100;
                this.shownNumbers.push({
                    value: numberValue,
                });
            }
        },
        addNumber: function(value) {
            this.$store.dispatch('betModule/setBetDataByKey', {
                key: 'numbers',
                value: [...this.betData.numbers, parseFloat(value)],
            });
        },
        handleCheckedNumber: function(value) {
            this.addNumber(value);
        },
        handleUnCheckedNumber: function(value) {
            const newNumbers = this.betData.numbers.filter(
                number => number !== value,
            );
            this.$store.dispatch('betModule/setBetDataByKey', {
                key: 'numbers',
                value: newNumbers,
            });
        },
        onErrorChecked: function() {
            this.$swal.fire({
                title:
                    '<div class="popup__icon popup__icon--limit-number"></div>',
                html: `<b>Bạn chỉ chọn tối đa ${this.max_number} số</b>`,
                customClass: {
                    popup: 'swal2-popup-warning-custom',
                },
                showCloseButton: true,
            });
        },
        handleSearchNumber: function() {
            if (this.searchNumber === '') {
                this.isSearchError = true;
            } else {
                this.isSearchError = false;
                const searchNumber = parseFloat(this.searchNumber);
                if (
                    searchNumber < Math.pow(10, this.getNumberLength()) &&
                    !this.betData.numbers.includes(searchNumber)
                ) {
                    if (this.countChosenNumbers < this.max_number) {
                        this.addNumber(searchNumber);
                        this.countChosenNumbers++;
                        this.searchNumber = '';
                    } else {
                        this.onErrorChecked();
                    }
                }
            }
        },
        handleActiveChosenNumber: function() {
            this.isActiveChosenNumber = !this.isActiveChosenNumber;
        },
        getNumberLength: function() {
            const gameType = this.gameInfo.type;
            const gameCode = this.gameInfo.code;
            if (gameType === 'dauduoi') {
                return 1;
            }
            if (
                gameType === '3cang' ||
                gameCode === 'loto_3so' ||
                gameType === 'xiuchu'
            ) {
                return 3;
            }
            return 2;
        },
        updateHistory: async function() {
            if (this.betHistory) {
                if (this.history === null) this.history = [];
                const filteredNumberLists = this.betHistory
                    .filter(
                        bet =>
                            bet.category.code.toString() ===
                            this.gameInfo.code.toString(),
                    )
                    .sort(function(a, b) {
                        return (
                            Date.parse(a.create_at) - Date.parse(b.create_at)
                        );
                    })
                    .map(bet => bet.numbers);
                filteredNumberLists.forEach(numberList => {
                    const numberArr = numberList.split('-');
                    numberArr.forEach(number => {
                        const numberValue = parseFloat(number);
                        if (
                            this.history.length < 9 &&
                            !this.history.includes(numberValue)
                        ) {
                            this.history.push(numberValue);
                        }
                    });
                });
            }
        },
    },
};
</script>
<style scoped lang="scss">
@import 'List';
</style>
